export default "__VITE_ASSET__BjbL4pvL__"